// components/Frameworks.js
import React, { useState } from 'react';
import './Frameworks.css';
import CodeBlock from './CodeBlock';

const Frameworks = () => {
  const [activeTab, setActiveTab] = useState('pytorch');
  
  const pytorchCode = `from cinder import ModelDebugger
import torch

CINDER_API_KEY = "your-api-key"

# Create debugger with PyTorch model
debugger = ModelDebugger(
    model=model,            # PyTorch nn.Module
    dataset=test_loader,    # PyTorch DataLoader
    name="PyTorch Model",
    api_key=CINDER_API_KEY
)

# Get metrics and analysis
results = debugger.analyze()

# Launch interactive dashboard
debugger.launch_dashboard(port=8000)

# Get improvement suggestions
suggestions = debugger.get_improvement_suggestions()`;

  const tensorflowCode = `from cinder import ModelDebugger
import tensorflow as tf

CINDER_API_KEY = "your-api-key"

# Initialize debugger with TensorFlow model
# Note: Some features have limited TensorFlow support
debugger = ModelDebugger(
    model=model,            # Keras/TensorFlow model 
    dataset=dataset,        # TensorFlow dataset
    name="TensorFlow Model",
    api_key=CINDER_API_KEY
)

# Basic analysis is supported
results = debugger.analyze()

# Launch interactive dashboard
debugger.launch_dashboard(port=8000)`;

  const sklearnCode = `from cinder import ModelDebugger
from sklearn.ensemble import RandomForestClassifier

CINDER_API_KEY = "your-api-key"

# Initialize with sklearn model
# Note: Some advanced features have limited sklearn support
debugger = ModelDebugger(
    model=model,            # Any sklearn model
    dataset=dataset,        # Dataset wrapper
    name="Random Forest",
    feature_names=features,  # Feature names
    api_key=CINDER_API_KEY
)

# Basic analysis is supported
results = debugger.analyze()

# Launch interactive dashboard
debugger.launch_dashboard(port=8000)`;

  return (
    <section className="frameworks" id="frameworks">
      <div className="section-header">
        <h2>Framework Support</h2>
        <p>Integration with major ML frameworks (PyTorch support most complete)</p>
      </div>
      
      <div className="framework-tabs">
        <button 
          className={`framework-tab ${activeTab === 'pytorch' ? 'active' : ''}`}
          onClick={() => setActiveTab('pytorch')}
        >
          PyTorch
        </button>
        <button 
          className={`framework-tab ${activeTab === 'tensorflow' ? 'active' : ''}`}
          onClick={() => setActiveTab('tensorflow')}
        >
          TensorFlow <span className="dev-pill small">Beta</span>
        </button>
        <button 
          className={`framework-tab ${activeTab === 'sklearn' ? 'active' : ''}`}
          onClick={() => setActiveTab('sklearn')}
        >
          scikit-learn <span className="dev-pill small">Beta</span>
        </button>
      </div>
      
      <div className="framework-container">
        <div className="framework-info">
          <h3>{activeTab === 'pytorch' ? 'PyTorch' : activeTab === 'tensorflow' ? 'TensorFlow' : 'scikit-learn'} Support</h3>
          <ul className="framework-features">
            {activeTab === 'pytorch' && (
              <>
                <li>Full support for nn.Module models</li>
                <li>Works with PyTorch DataLoader</li>
                <li>GPU acceleration support</li>
                <li>Complete implementation of all features</li>
              </>
            )}
            {activeTab === 'tensorflow' && (
              <>
                <li>Basic compatibility with TensorFlow models</li>
                <li>Support for core metrics and analysis</li>
                <li>Some advanced features in development</li>
                <li>Dashboard visualization support</li>
              </>
            )}
            {activeTab === 'sklearn' && (
              <>
                <li>Basic support for scikit-learn estimators</li>
                <li>Standard metrics and confusion matrix</li>
                <li>Direct access to feature importance when available</li>
                <li>Limited cross-validation analysis</li>
              </>
            )}
          </ul>
        </div>
        
        <div className="framework-code">
          <CodeBlock 
            code={activeTab === 'pytorch' ? pytorchCode : activeTab === 'tensorflow' ? tensorflowCode : sklearnCode}
            language="python"
            showLineNumbers={false}
          />
        </div>
      </div>
    </section>
  );
};

export default Frameworks;